<div class="modal-header">
  <h4 class="modal-title pull-left">Add Broker{{selectedBrokerage ? ' - '+ selectedBrokerage : ''}}</h4>
  <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef.hide()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body Broker-list">
  <div class="form-group" [hidden]="showBroker">
    <div class="table-responsive">
      <div>
        <input class="form-control be-input margin-bottom-20" [(ngModel)]="searchValue" (keyup)="onSearch(searchValue)" maxlength="200" placeholder="Search Brokers">
      </div>

      <table class="table basictable row-border hover" id="dtTable" datatable [dtOptions]="dtOptions">
        <tbody>
          <tr *ngFor="let user of users;let i = index ">
            <td>
              <ul class="connection-list brokerlist be-exchange-list">
                <li class="clearfix">

                  <div class="right">
                    <h6>
                      {{user.BrokerName}}
                    </h6>
                    <p>
                      <i class="icon-phone icon"></i> {{user.Phone|phone}}
                    </p>
                    <p>
                      <i class="icon-message icon"></i> {{user.Email}}
                    </p>
                  </div>
                </li>
              </ul>
              <p><a href="javascript:void(0);" class="be-small-atag pull-right" (click)="onUserAdd(user.Id,i)">Add</a></p>
            </td>
          </tr>
        </tbody>
        <tfoot>
          <tr *ngIf="users?.length == 0&&!IsLoading ">
            <td colspan="15" class="odd no-data-available">
              <div class="nodata">
                <i class="fa fa-exclamation-triangle icon"></i>
                <p>No Data Available</p>
              </div>
            </td>
          </tr>
        </tfoot>
      </table>
    </div>
  </div>

  <div [hidden]="!showBroker">

    <div class="form-group">
      <label class="form-label">First Name<span class="red">*</span></label>
      <input class="form-control" (keyup)="onBrokerInfoKeydown()" #brokerNameinput="ngModel" [(ngModel)]="brokerageBrokerInputModel.BrokerName" required type="text" maxlength="100">
      <p class="redtext" *ngIf="(brokerNameValid || (brokerNameinput.invalid && brokerNameinput.touched))">First name is required </p>
    </div>
    <div class="form-group">
      <label class="form-label">Last Name<span class="red">*</span></label>
      <input class="form-control" (keyup)="onBrokerInfoKeydown()" #brokerLastNameinput="ngModel" [(ngModel)]="brokerageBrokerInputModel.LastName" required type="text" maxlength="100">
      <p class="redtext" *ngIf="(lastNameValid || (brokerLastNameinput.invalid && brokerLastNameinput.touched))">Last name is required </p>
    </div>
    <div class="form-group">
      <label class="form-label">Email<span class="red">*</span></label>
      <input class="form-control" (keyup)="onBrokerInfoKeydown()" #emailinput="ngModel" autocomplete="off" maxlength="100" required [(ngModel)]="brokerageBrokerInputModel.Email">
      <p class="redtext" *ngIf="((emailValid) || emailinput.invalid && emailinput.touched) && emailvalidation=='' ">Email is required</p>
      <p class="redtext" *ngIf="(emailvalidation!='' && brokerageBrokerInputModel.Email!='' )">{{emailvalidation}}</p>
    </div>


    <div class="form-group">
      <label class="form-label">Direct<span class="red">*</span></label>
      <input class="form-control" (keyup)="onBrokerInfoKeydown()" #phoneNumberinput="ngModel" required [(ngModel)]="brokerageBrokerInputModel.Phone" mask='(000) 000-0000' maxlength="20" id="txtPhone">
      <p class="redtext" *ngIf="((phoneValid) || (phoneNumberinput.invalid && phoneNumberinput.touched) )&& phoneValidation =='' ">Phone number is required</p>
      <p class="redtext" *ngIf="(phoneValidation!='' && brokerageBrokerInputModel.Phone !='')">{{phoneValidation}}</p>
    </div>

    <div class="form-group" *ngIf="authService.Admin()||authService.SuperAdmin()">
      <label class="form-label">Mobile</label>
      <input class="form-control" #additionalPhoneNumberinput="ngModel" required [(ngModel)]="brokerageBrokerInputModel.AdditionalPhone" mask='(000) 000-0000' maxlength="20" id="txtAdditionalPhone">
    </div>

    <!--<div class="form-group" *ngIf="authService.Admin()">
      <label class="form-label">Extension Number</label>
      <input class="form-control" #extensionNumberinput="ngModel" required [(ngModel)]="brokerageBrokerInputModel.ExtensionNumber" mask="9999999999" maxlength="20" id="txtExtensionNumber">
    </div>-->

    <div class="form-group">
      <label class="form-label">Title<span class="red">*</span></label>
      <input class="form-control" (keyup)="onBrokerInfoKeydown()" #titleinput="ngModel" required [(ngModel)]="brokerageBrokerInputModel.Title" maxlength="100" id="txtTitle">
      <p class="redtext" *ngIf="(brokerTitleValid || (titleinput.invalid && titleinput.touched) )">Title is required</p>
    </div>


    <div class="text-right">
      <button class="btn btn-lg btn-default" id="closeModal" (click)="closeAddBrokerModal()">Cancel</button>
      <button class="btn btn-lg btn-success" [disabled]="disabledAddOrEditBtn" (click)="addOrEditBroker();">Save</button>
    </div>
  </div>

  <div class="modal-footer modal-fixted-footer" [hidden]="showBroker">
    <a (click)="addBro()" tooltip="Add new external broker" placement="left" class="right-btn btn  btn-circle btn-green adduserbtn">
      <i class="icofont icofont-plus icon" aria-hidden="true"></i>
    </a>
  </div>
</div>


